export enum ColorDistributionType {
    None = 0,
    Status = 1,
    CoverHandle = 2,
    CoverExact = 3,
    BestHandle = 4,
    BestExact = 5
}
